"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.getCountryById = exports.getCountries = void 0;

var _pipe = _interopRequireDefault(require("./pipe"));

var _countryList = _interopRequireDefault(require("./countryList"));

var sortAlphabetically = function sortAlphabetically(countryList) {
  return countryList.sort(function (a, b) {
    return a.name > b.name ? 1 : -1;
  });
};

var sortUKFirst = function sortUKFirst(countryList) {
  var uk = countryList.find(function (country) {
    return country.code === "GB";
  });
  return uk // don't modify the list if the UK can't be found.
  ? [uk].concat(countryList.filter(function (country) {
    return country.code !== "GB";
  })) : countryList;
};

var getCountries = function getCountries(list) {
  if (list === void 0) {
    list = _countryList["default"];
  }

  return (0, _pipe["default"])(sortAlphabetically, sortUKFirst)(list);
};

exports.getCountries = getCountries;

var getCountryById = function getCountryById(id) {
  return _countryList["default"].find(function (country) {
    return country.id === id;
  });
};

exports.getCountryById = getCountryById;